// react
import { useContext, useEffect, useState } from "react";
// libs
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useTitle } from "react-use";
// components
import { HeaderSpacer } from "../components/HeaderSpacer";
import ATHero from "../components/artifact-theme/ATHero";
import { PTOther } from "../components/artifact-theme/ATOther";
import ATOverlay from "../components/artifact-theme/ATOverlay";
import ATSlider from "../components/artifact-theme/ATSlider";
import { LayoutScroll } from "../layout/LayoutScroll";
import { Box } from "../components/Box";
// context
import { ArtifactViewSelectionProvider } from "../context/ArtifactViewSelectionContext";
import { ArtifactThemesContext } from "../context/ArtifactsContext";
// hooks
import { useSetLogoStyle } from "../hooks/useSetLogoStyle";
// other
import { getArtifactThemes } from "../api/api";
import { allAvailableArtifacts } from "../helpers/transformers/product-theme";
import { Colors } from "../models/theme";
import { ArtifactTheme } from "../models/client";

const Bg = styled.div<{ bgColor: keyof Colors }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme, bgColor }) => theme.colors[bgColor]};
  z-index: -1;
`;

export const ArtifactThemePage: React.FC = () => {
  const { artifactThemes, setArtifactThemes } = useContext(
    ArtifactThemesContext
  );

  const [artifactTheme, setArtifactTheme] = useState<ArtifactTheme | null>(
    null
  );
  const params = useParams() as { themeId: string };

  useEffect(() => {
    if (!artifactThemes.length) {
      getArtifactThemes().then((artifactThemes) => {
        if (artifactThemes) {
          setArtifactThemes(artifactThemes);
          const artifactTheme =
            artifactThemes.find((at) => at.slug === params.themeId) || null;
          setArtifactTheme(artifactTheme);
        }
      });
    } else {
      const artifactTheme =
        artifactThemes.find((at) => at.slug === params.themeId) || null;
      setArtifactTheme(artifactTheme);
    }
  }, [params, artifactThemes, setArtifactThemes]);

  useSetLogoStyle("dark");

  useTitle(`${artifactTheme?.name} | Boots Exhibition`);

  if (!artifactTheme) {
    return <div>loading...</div>;
  }

  console.log(artifactTheme);
  return (
    <LayoutScroll>
      <Box position="relative" height="100%">
        {artifactTheme ? (
          <ArtifactViewSelectionProvider
            availableArtifacts={allAvailableArtifacts(artifactTheme)}
          >
            <>
              <HeaderSpacer />
              <Bg bgColor={artifactTheme.color}></Bg>
              <ATHero artifactTheme={artifactTheme} />
              <ATSlider artifactTheme={artifactTheme} />
              <PTOther artifactTheme={artifactTheme} />
              <ATOverlay
                artifacts={allAvailableArtifacts(artifactTheme)}
              ></ATOverlay>
            </>
          </ArtifactViewSelectionProvider>
        ) : null}
      </Box>
    </LayoutScroll>
  );
};
